export default __webpack_public_path__ + "static/media/LogoTB.6936aec6.svg";